import React from 'react';
import { withRouter } from 'react-router-dom';
import { Form } from 'react-final-form';
import memoize from 'lru-memoize';

import { Button } from '../../elements';
import { createValidator, required } from '../../redux/utils/validation';
import ModalContainer from '../../elements/ModalContainer/ModalContainer';
import modal from '../../elements/ModalContainer/ModalContainer.module.scss';
import strings from '../../lang/lang';
import { FormInput, FormSelect, FormCheckbox } from '../../elements/Form';
import { setLoading } from '../../redux/loading/loadingActions';
import { appsActions, createAppModalState } from '../../redux/reducers/apps';
import { showError } from '../../elements/Toasts/toastActions';
import { useAppSelector, useAppDispatch } from '../../hooks/useRedux';

function CreateAppModal(props) {
  const { history } = props;
  const dispatch = useAppDispatch();
  const isVisibleCreateAppModal = useAppSelector(createAppModalState);

  const validate = memoize(10)(
    createValidator({
      name: [required],
      type: [required],
    })
  );

  function onSubmit({ name, type, is2faEnabled = false }) {
    setLoading(true);
    const data = {};
    if (type.value === 'B2B') {
      data['name'] = name;
      data['type'] = 'B2B';
    } else {
      data['name'] = name;
      data['type'] = 'B2C';
      data['is2faEnabled'] = is2faEnabled;
    }

    return new Promise((res, rej) => {
      dispatch(appsActions.createApp({ data, res, rej }));
    })
    .then((res) => {
      history.push(`/apps/${res.data.id}`);
    })
    .catch(() => {
      showError(strings.appList.errors.creatingApp);
    })
    .finally(() => {
      setLoading(false);
      dispatch(appsActions.toogleCreateAppModal(false));
    });
  }

  return (
    <ModalContainer
      isOpen={isVisibleCreateAppModal}
      closeModalWindow={() => dispatch(appsActions.toogleCreateAppModal(false))}
      title={strings.appList.text.modalCreateAppTitle}
    >
      <Form
        onSubmit={onSubmit}
        validate={validate}
        render={({ handleSubmit, values }) => {
          const type = values.type ? values.type.value : 'B2B';

          return (
            <form onSubmit={handleSubmit}>
              <FormInput name="name" label={strings.appList.fields.appName} autoFocus />
              <FormSelect
                options={[
                  { value: 'B2B', label: 'B2B' },
                  { value: 'B2C', label: 'B2C' },
                ]}
                name="type"
                label="app type"
              />
              {type === 'B2C' && (
                <FormCheckbox
                  className="createAppForm"
                  name="is2faEnabled"
                  label="Enable 2FA for application users"
                />
              )}
              <div className={modal['react-modal__btn-box']}>
                <Button
                  name={strings.appList.buttons.createNew}
                  variant="primary"
                  secondaryClassName="popup_primary"
                  type="submit"
                />
              </div>
              <div className={modal['react-modal__btn-box']}>
                <Button
                  name={strings.appWebhooks.buttons.cancel}
                  variant="secondary"
                  secondaryClassName="popup_secondary"
                  type="button"
                  onClick={() => dispatch(appsActions.toogleCreateAppModal(false))}
                />
              </div>
            </form>
          );
        }}
      />
    </ModalContainer>
  );
}

export default withRouter(CreateAppModal);
